import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=6ddf0f3a&scoped=true&lang=pug"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf0f3a",
  null
  
)

export default component.exports